module.exports = __webpack_public_path__ + "media/images/public-goods-38c93a6791fa67fb903abe11885d43f4.png";